export interface EmailVariableInfo {
	name: string;
	label: string;
	description: string;
}

const CATALOG: Record<string, Omit<EmailVariableInfo, 'name'>> = {
	investor_login_url: {
		label: 'Investor sign-in link',
		description: 'Link that takes the investor to their sign-in page.',
	},
	investor_full_name: {
		label: 'Investor name',
		description: "The investor's full name.",
	},
	entity_name: {
		label: 'Entity name',
		description: 'The investing entity this email relates to.',
	},
	project_name: {
		label: 'Project name',
		description: 'The name of the project or deal.',
	},
	deal_name: {
		label: 'Deal name',
		description: 'The name of the deal.',
	},
	programme_name: {
		label: 'Programme name',
		description: 'The name of the investment programme.',
	},
	document_name: {
		label: 'Document name',
		description: 'The name of the document being referenced.',
	},
	signatory_name: {
		label: 'Signatory name',
		description: 'The name of the person asked to sign.',
	},
	signing_url: {
		label: 'Signing link',
		description: 'Link that opens the document to review and sign.',
	},
	redirect_url: {
		label: 'Invitation link',
		description: 'Link the recipient follows to accept the invitation.',
	},
	reset_password_url: {
		label: 'Password reset link',
		description: 'Link that lets the recipient reset their password.',
	},
	verification_code: {
		label: 'Verification code',
		description: 'One-time code used to verify the email address.',
	},
	custom_text: {
		label: 'Custom message',
		description: 'Optional custom message shown in the email body.',
	},
	first_name: {
		label: 'First name',
		description: "The recipient's first name, used in the greeting.",
	},
	deal_manager_name: {
		label: 'Deal manager name',
		description: 'Name of the deal manager the investor should contact.',
	},
	deal_manager_email: {
		label: 'Deal manager email',
		description: 'Email address of the deal manager.',
	},
	piv_name: {
		label: 'Investing vehicle name',
		description: 'Name of the investing vehicle (PIV) making the investment.',
	},
	piv_signer_first_name: {
		label: 'Vehicle signatory first name',
		description: "First name of the vehicle's signatory.",
	},
	link: {
		label: 'Link',
		description: 'The action link for this email.',
	},
	type: {
		label: 'Type',
		description: 'The type or role referenced in the email.',
	},
	login_url: {
		label: 'Sign-in link',
		description: 'Link that takes the recipient to their sign-in page.',
	},
	mip_name: {
		label: 'Programme name',
		description: 'The name of the programme this email relates to.',
	},
	export_date: {
		label: 'Export date',
		description: 'The date the export or download was generated.',
	},
};

const humanize = (name: string): string =>
	name
		.replace(/_/g, ' ')
		.replace(/\burl\b/gi, 'link')
		.replace(/^\w/, (c) => c.toUpperCase());

export const getVariableInfo = (name: string): EmailVariableInfo => {
	const known = CATALOG[name];
	return {
		name,
		label: known?.label ?? humanize(name),
		description: known?.description ?? '',
	};
};

export const getVariableToken = (name: string): string => `{{ ${name} }}`;
